import React, { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { API, axios } from '../../utils/api';
import { giornoEMese, leggiDataUtc, migliaia } from '../../utils/percorso';
import Icona from '../cliente/Icone';

// Impostazioni → Estrattore → "Verifica filtri" (backend/verifica_filtri.py): per ogni portale × filtro che la ricerca
// automatica mette nel link, se il portale lo applica davvero (letto dalla pagina dall'estensione 2.7.0), con data e
// dettaglio. Un filtro non applicato è già tolto dal link e si controlla sui risultati letti.
const PORTALI = { immobiliare: 'immobiliare.it', idealista: 'idealista', casa: 'casa.it' };
const ESITI = {
  applicato: { testo: 'applicato', tag: 't-g' },
  non_applicato: { testo: 'non applicato', tag: 't-r' },
  non_verificabile: { testo: 'non verificabile', tag: 't-w' },
};

const VerificaFiltri = () => {
  const [dati, setDati] = useState(null);
  const [attesa, setAttesa] = useState(false);
  useEffect(() => { axios.get(`${API}/admin/verifica-filtri`).then((r) => setDati(r.data)).catch(() => {}); }, []);
  const lancia = async () => {
    setAttesa(true);
    try {
      const r = await axios.post(`${API}/admin/verifica-filtri/lancia`);
      setDati(r.data);
      if (r.data.messe) toast.success(`${r.data.messe === 1 ? '1 pagina' : `${r.data.messe} pagine`} in coda: l'estensione le apre una alla volta, con le sue pause`);
      else toast.error(r.data.motivo === 'ci sono già verifiche in coda' ? 'Ci sono già verifiche in coda' : 'Nessuna ricerca da verificare: servono clienti con budget e comuni');
    } catch { toast.error('Non riuscito'); } finally { setAttesa(false); }
  };
  if (!dati?.righe) return null;
  const bagni = dati.righe.find((r) => r.portale === 'immobiliare' && r.filtro === 'bagni');
  const pianificata = leggiDataUtc(dati.pianificata);
  return (
    <section className="card" data-testid="verifica-filtri">
      <div className="ttl"><div className="i g"><Icona nome="fatto" /></div><h2>Verifica filtri</h2>
        {dati.in_coda > 0 && <span className="tag t-b">{dati.in_coda} in coda</span>}
        <button type="button" className="btn sm" disabled={attesa || dati.in_coda > 0} onClick={lancia}>{attesa ? 'Metto in coda…' : 'Verifica di nuovo'}</button></div>
      <p className="imp-nota">
        L'estensione (dalla {dati.versione_minima}) apre gli indirizzi delle ricerche dei clienti e legge dalla pagina i filtri che il portale mostra
        come applicati: al massimo {dati.massimo} pagine, una alla volta con le sue pause. Un filtro <b>non applicato</b> esce dal link da solo e lo
        controlliamo sui risultati letti; ve lo diciamo anche in Oggi.
        {pianificata ? ` Ultima verifica messa in coda il ${giornoEMese(pianificata)}.` : ' Parte da sola la prima volta che l\'estensione 2.7.0 chiede lavoro.'}
      </p>
      {bagni?.modo && (
        <p className="avviso-bagni" data-testid="bagni-immobiliare">
          <b>Bagni su immobiliare.it: {bagni.modo === 'esattamente' ? 'esattamente N' : 'N o più'}.</b> {bagni.dettaglio}.
          {bagni.modo === 'esattamente' ? ' Nel link mettiamo solo «più di 3» (bagni=4); gli altri minimi li controlliamo sulle schede.' : ''}
        </p>
      )}
      <div className="tabella-box" style={{ marginTop: '.8rem' }}>
        <table className="tabella verifica">
          <thead><tr><th>Portale</th><th>Filtro</th><th>Esito</th><th>Data</th><th>Dettaglio</th></tr></thead>
          <tbody>
            {dati.righe.map((r) => {
              const e = ESITI[r.esito];
              const data = leggiDataUtc(r.data);
              return (
                <tr key={`${r.portale}-${r.filtro}`} data-testid={`verifica-${r.portale}-${r.filtro}`}>
                  <td className="nowrap">{PORTALI[r.portale] || r.portale}</td>
                  <td className="nowrap">{r.nome}<small>{r.usato ? `in ${r.usato} ${r.usato === 1 ? 'ricerca' : 'ricerche'}` : 'nessuna ricerca lo usa'}</small></td>
                  <td className="nowrap">{e ? <span className={`tag ${e.tag}`}>{e.testo}</span> : <span className="muto">da verificare</span>}
                    {!r.nel_link && <small>tolto dal link</small>}</td>
                  <td className="nowrap">{data ? giornoEMese(data) : '—'}{r.totale !== null && r.totale !== undefined ? <small>{migliaia(r.totale)} risultati</small> : null}</td>
                  <td>{r.dettaglio || '—'}{r.url && <small><a href={r.url} target="_blank" rel="noopener noreferrer">pagina verificata ↗</a>{r.origine ? ` · ${r.origine}` : ''}</small>}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </section>
  );
};

export default VerificaFiltri;
